import { ButtonHTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';
import tw from 'twin.macro';

import { OpenInNewTabIcon } from '@icons/OpenInNewTabIcon';

export const ChartLegendButton = tw.button`flex items-center gap-[6px] py-[4px] px-[6px] rounded border border-gray-1 cursor-pointer text-[11px] text-text-and-icon font-medium bg-page-background whitespace-nowrap`;
export const ChartLegendIconWrapper = tw.div`min-w-[18px] flex justify-center items-center`;

export const SeeEpisodesButton = (props: ButtonHTMLAttributes<HTMLButtonElement>) => {
  const { t } = useTranslation();

  return (
    <ChartLegendButton {...props}>
      {t('insights.overview_page.brand_safety_section.see_episodes_list')}
      <ChartLegendIconWrapper>
        <OpenInNewTabIcon width={14} height={14} />
      </ChartLegendIconWrapper>
    </ChartLegendButton>
  );
};
